export const getProductTypeImageSrc = (
  imageBaseUrl: string,
  productTypeId: string,
  viewId: string,
  appearanceId: string,
  modelId?: string,
  crop?: Crop,
  width?: number,
  height?: number,
  backgroundColor?: string,
  mediaType?: 'webp' | 'jpg' | undefined
): string => {
  const url = new URL(
    `${imageBaseUrl}/productTypes/${productTypeId}/views/${viewId}/appearances/${appearanceId}${mediaType ? `.${mediaType}` : ''}`
  );

  if (width) url.searchParams.append('width', width.toString());
  if (height) url.searchParams.append('height', height.toString());
  if (modelId) url.searchParams.append('modelId', modelId);
  if (crop) url.searchParams.append('crop', crop);
  if (backgroundColor) url.searchParams.append('backgroundColor', backgroundColor.replace('#', ''));

  return url.toString();
};

export const getProductTypeSizeImageSrc = (
  imageBaseUrl: string,
  productTypeId: string,
  width: number,
  height?: number,
  mediaType?: 'webp' | 'jpg' | undefined
): string => {
  const url = new URL(
    `${imageBaseUrl}/productTypes/${productTypeId}/variants/size${mediaType ? `.${mediaType}` : ''}`
  );

  if (width) url.searchParams.append('width', width.toString());
  if (height) url.searchParams.append('height', height.toString());

  return url.toString();
};

const createParamsString = (params: Record<string, string | number | undefined>): string =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value!.toString()}`)
    .join(',');

export const getProductImageSrc = (
  imageBaseUrl: string,
  vpString: string,
  viewId: string,
  appearanceId: string,
  modelId?: string,
  crop?: Crop,
  width?: number,
  height?: number,
  backgroundColor: string = '#F2F2F2'
): string => {
  // We use the params string in order to have similar image urls like the OCJ.
  const paramsString = createParamsString({
    appearanceId: appearanceId ? appearanceId.toString() : undefined,
  });

  const urlParams = new URLSearchParams();
  if (width) urlParams.append('width', width.toString());
  if (height) urlParams.append('height', height.toString());
  if (backgroundColor) urlParams.append('backgroundColor', backgroundColor.replace('#', ''));
  if (modelId) urlParams.append('modelId', modelId);
  if (crop) urlParams.append('crop', crop);

  const url = new URL(
    `${imageBaseUrl}/products/${encodeURIComponent(decodeURIComponent(vpString))}/views/${viewId}${paramsString.length ? `,${paramsString}` : ''}.jpg${urlParams.toString() ? `?${urlParams.toString()}` : ''}`
  );

  return url.toString();
};

export const getCompositionImageSrc = (
  imageBaseUrl: string,
  vpString: string,
  viewId: string,
  appearanceId: string,
  width?: number,
  height?: number,
  backgroundColor?: string
) => {
  const paramsString = createParamsString({
    appearanceId: appearanceId ? appearanceId.toString() : undefined,
    backgroundColor: backgroundColor ? backgroundColor.replace('#', '') : undefined,
  });

  const urlParams = new URLSearchParams();
  if (width) urlParams.append('width', width.toString());
  if (height) urlParams.append('height', height.toString());

  const url = new URL(
    `${imageBaseUrl}/compositions/${encodeURIComponent(decodeURIComponent(vpString))}/views/${viewId}${paramsString.length ? `,${paramsString}` : ''}.jpg${urlParams.toString() ? `?${urlParams.toString()}` : ''}`
  );

  return url.toString();
};

export const getShowroomBannerImageSrc = (imageBaseUrl: string, userId: string, width?: number) =>
  [`${imageBaseUrl}/users/${userId}/banner`, width ? ',maxWidth=' + width : '', '.webp'].join('');

export const getUserImageSrc = (
  imageBaseUrl: string,
  userId: string,
  width: number = 100,
  height?: number,
  mediaType?: 'webp' | 'jpg' | undefined
): string => {
  return `${imageBaseUrl}/users/${userId},width=${width},height=${height ?? width}${mediaType ? `.${mediaType}` : ''}`;
};
